module.exports = __webpack_public_path__ + "static/media/doc.47630114.PNG";